import { Link } from "react-router-dom";
import { useUpcomingDates, usePastDates, usePageMeta } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import EventRow from "@/components/site/EventRow";

export default function Dates() {
  usePageMeta(
    "Dates — SEIMEN DEXTER | Hard / Industrial Techno",
    "Upcoming and past live dates of SEIMEN DEXTER — Hard / Industrial Techno from Mannheim, Germany. Tickets and event info."
  );
  const { data: upcoming, isLoading } = useUpcomingDates();
  const { data: past } = usePastDates();

  return (
    <div className="px-5 md:px-10 pt-28 md:pt-40 pb-24 md:pb-36">
      <Reveal>
        <p className="kicker mb-6">LIVE</p>
        <h1 className="font-display text-6xl md:text-8xl leading-none mb-4 md:mb-6">DATES</h1>
        <p className="kicker">165 BPM — LIVE ON STAGE</p>
      </Reveal>

      <section data-testid="upcoming-dates" className="mt-14 md:mt-20">
        <h2 className="text-[11px] tracking-[0.3em] text-white/40 mb-6">UPCOMING DATES</h2>
        {isLoading ? (
          <div className="border-t border-line py-16 text-white/40 text-sm">LOADING…</div>
        ) : upcoming && upcoming.length > 0 ? (
          <div className="border-b border-line">
            {upcoming.map((ev) => (
              <EventRow key={ev.id} ev={ev} />
            ))}
          </div>
        ) : (
          <div data-testid="dates-empty" className="border-t border-line py-16 md:py-20">
            <p className="font-display text-5xl md:text-6xl leading-[0.95]">NO DATES ANNOUNCED YET.</p>
            <p className="kicker mt-4">NEW SHOWS ARE ADDED REGULARLY — BOOKING IS OPEN</p>
            <Link data-testid="dates-empty-booking" to="/booking" className="btn-ghost mt-8">
              BOOK SEIMEN DEXTER
            </Link>
          </div>
        )}
      </section>

      {past && past.length > 0 && (
        <section data-testid="past-dates" className="mt-20 md:mt-28">
          <h2 className="text-[11px] tracking-[0.3em] text-white/40 mb-6">PAST DATES</h2>
          <div className="border-b border-line">
            {past.map((ev) => (
              <EventRow key={ev.id} ev={ev} past />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
